import { render, staticRenderFns } from "./showPnr.vue?vue&type=template&id=18c709c2&"
import script from "./showPnr.vue?vue&type=script&lang=js&"
export * from "./showPnr.vue?vue&type=script&lang=js&"
import style0 from "./showPnr.vue?vue&type=style&index=0&id=18c709c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports